module.exports = __webpack_public_path__ + "img/MARCA_SEM_BORDA.306a8aeb.png";